export const setDecorations = (editor, decorations) => {
  return {
    ...editor,
    decorations,
  }
}
